// @flow
import * as React from 'react'
import { isSyntheticEvent } from '../../utils'

// Types
import type { Input } from '../BaseField'

export type Props = {
  input: Input,
  normalizer: (nextValue: any, value: any) => any,
  render: (input: Input) => React.Node,
}

/**
 * A component that provides a value filtering functionality with render prop
 * for `redux-form` style input components. It replace `onChange` in given input
 * object and call original `onChange` with result from `normalize` function.
 */
class NormalizeValue extends React.Component<Props> {
  handleChangeValue = (event: any) => {
    const { normalizer, input = {} } = this.props
    const eventValue = isSyntheticEvent(event) ? event.target.value : event
    const result = normalizer(eventValue, input.value)
    input.onChange && input.onChange(result)
  }

  render() {
    const { input, render } = this.props
    return render({
      ...input,
      onChange: this.handleChangeValue,
    })
  }
}

export default NormalizeValue
